import { DATE_FORMAT, DATE_ISO8601_FORMAT } from '@/constants';
import dayjs, { Dayjs } from 'dayjs';
import { DatePicker } from 'antd';
import { useMemo } from 'react';

type DateInputProps = {
  /** Called with ISO8601 date string (YYYY-MM-DDTHH:mm:ssZ) or null when cleared */
  onChange: (date: string | null) => void;
  disabled?: boolean;
  /** Accepts ISO8601 datetime or YYYY-MM-DD date strings */
  value?: string | null;
  placeholder?: string;
};

export default function DateInput({
  value,
  onChange,
  disabled = false,
  placeholder,
}: DateInputProps) {
  const dateValue = useMemo(() => {
    if (!value) return null;
    const iso = dayjs(value, DATE_ISO8601_FORMAT);
    if (iso.isValid()) return iso;
    const fallback = dayjs(value);
    return fallback.isValid() ? fallback : null;
  }, [value]);

  const handleChange = (date: Dayjs | null) => {
    if (date) {
      onChange(date.format(DATE_ISO8601_FORMAT));
    } else {
      onChange(null);
    }
  };

  return (
    <div>
      <DatePicker
        value={dateValue}
        onChange={handleChange}
        format={DATE_FORMAT}
        disabled={disabled}
        inputReadOnly={false}
        allowClear
        style={{ width: '100%' }}
        placeholder={placeholder ?? 'Select Date (YYYY-MM-DD)'}
        size="small"
        getPopupContainer={() => document.body}
      />
    </div>
  );
}
